import { render, staticRenderFns } from "./SettingsProducttypesPage.vue?vue&type=template&id=088b2f3c"
import script from "./SettingsProducttypesPage.vue?vue&type=script&lang=js"
export * from "./SettingsProducttypesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports